export default (str) => /\S+@\S+\.\S+/.test(str);
